import React, { useContext } from 'react';
import { Container } from '@inlet/react-pixi'

import HomeContext from '../../context/home-context';
import LearningMaxLevel from './IslandDecorationAssets/LearningMaxLevel'
import MindsetMaxLevel from './IslandDecorationAssets/MindsetMaxLevel'
import WellbeingMaxLevel from './IslandDecorationAssets/WellbeingMaxLevel'
import ResilienceMaxLevel from './IslandDecorationAssets/ResilienceMaxLevel'

const IslandDecoration = () => {
    const { homeContext } = useContext(HomeContext);

    return (
        <Container>
            {
                homeContext.resilience.traitGroupScore > 110 ?
                    <ResilienceMaxLevel _xPos={400} _yPos={300} _traitGroupScore={homeContext.resilience.traitGroupScore} _traitGroupId={homeContext.resilience.id}/>
                    : <></>
            }
            {
                homeContext.wellbeing.traitGroupScore > 110 ?
                    <WellbeingMaxLevel _xPos={800} _yPos={300} _traitGroupScore={homeContext.wellbeing.traitGroupScore} _traitGroupId={homeContext.wellbeing.id}/>
                    : <></>
            }
            {
                homeContext.mindset.traitGroupScore > 110 ?
                    <MindsetMaxLevel _xPos={800} _yPos={700} _traitGroupScore={homeContext.mindset.traitGroupScore} _traitGroupId={homeContext.mindset.id} />
                    : <></>
            }
            {
                homeContext.learning.traitGroupScore > 110 ?
                    <LearningMaxLevel _xPos={1500} _yPos={400} _traitGroupScore={homeContext.learning.traitGroupScore} _traitGroupId={homeContext.learning.id} />
                    : <></>
            }   
        </Container>
    );
}

export { IslandDecoration as default }

//<Ferry _xPos={900} _yPos={60} speed={0.003} max={400} min={400} />
//<Ship _xPos={1500} _yPos={400} speed={0.004} max={890} min={400} route={goToSurvey} />
//<Dolphin _xPos={600} max={600} min={400} />